import { Controller } from "@hotwired/stimulus"

// The username pop-up (shared/_username_modal), for someone without one:
// - a link marked `data-username-required` (its value, if any, says why)
//   opens it in place of navigating; saving carries on to the link's href.
//   With no JS the link goes there and the server asks on its own page.
// - a checkbox marked the same (a collection's Public switch) opens it as
//   it's switched on; saving keeps it on without leaving the page (the
//   username saves in place), and closing it any other way switches it back.
export default class extends Controller {
  static targets = ["returnTo", "reason", "input"]

  connect() {
    this.defaultReason = this.reasonTarget.textContent
  }

  intercept(event) {
    const link = event.target.closest("a[data-username-required]")
    if (!link || event.defaultPrevented) return
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    const url = new URL(link.href, window.location.origin)
    this.returnToTarget.value = url.pathname + url.search
    this.open(link)
  }

  switched(event) {
    const box = event.target
    if (!box.matches?.("input[type=checkbox][data-username-required]") || !box.checked) return

    this.box = box
    this.saved = false
    this.open(box)
  }

  open(trigger) {
    const reason = trigger.dataset.usernameRequired
    this.reasonTarget.textContent = reason && reason !== "true" ? reason : this.defaultReason
    this.element.showModal()
    this.inputTarget.focus()
  }

  // Opened from a switch: save the username in place and stay on the page.
  async submit(event) {
    if (!this.box) return
    event.preventDefault()
    const form = event.target
    const status = form.querySelector("[data-username-check-target=status]")
    try {
      const response = await fetch(form.action, { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || "That didn't save. Try again?")
      this.saved = true
      // They have one now: nothing needs to ask again.
      document.querySelectorAll("[data-username-required]").forEach((el) => el.removeAttribute("data-username-required"))
      this.close()
    } catch (error) {
      status.textContent = error.message
      status.className = "un-status is-bad"
    }
  }

  close() {
    this.element.close()
  }

  // However it closed (X, backdrop, Escape), a switch it opened for stays
  // on only if the username saved.
  closed() {
    if (this.box && !this.saved) {
      this.box.checked = false
      this.box.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.box = null
  }

  // Clicks on the dialog element itself (not its contents) are backdrop clicks.
  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
